import React from "react";

// Página PÚBLICA de retorno cuando el usuario abandona/cancela el checkout.
// No se realizó ningún cargo. La reserva pendiente expira sola y libera el lugar.

function ReservaCancelado() {
  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9", display: "flex",
      alignItems: "center", justifyContent: "center", padding: "24px 12px" }}>
      <div style={{ maxWidth: 460, width: "100%", background: "#fff", borderRadius: 16,
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)", padding: "36px 28px", textAlign: "center" }}>
        <div style={{ width: 68, height: 68, borderRadius: "50%", background: "#fef3c7",
          display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9.5" /><line x1="12" y1="8" x2="12" y2="13" />
            <circle cx="12" cy="16.5" r="0.6" fill="#d97706" strokeWidth="0" />
          </svg>
        </div>
        <h2 style={{ margin: 0, fontSize: "1.35rem", fontWeight: 800, color: "#0f172a" }}>No se completó el pago</h2>
        <p style={{ margin: "10px 0 0", color: "#475569", fontSize: "0.9rem", lineHeight: 1.5 }}>
          No se realizó ningún cargo. Si quieres, puedes intentar tu reserva de nuevo.
        </p>
        <a href="/lugares-fiestas" style={{ display: "inline-block", marginTop: 22, border: "none",
          borderRadius: 10, padding: "11px 22px", fontWeight: 700, fontSize: "0.88rem",
          color: "#fff", background: "#10b981", textDecoration: "none" }}>
          Volver a intentar
        </a>
      </div>
    </div>
  );
}

export default ReservaCancelado;
